import React, { useState, useEffect, useRef } from 'react';
import { Form, Row, Col, Button, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { BsCalendar } from 'react-icons/bs';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import '../styles/main.css';
import { apiGet, apiPost } from '../services/api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const UserTaskUpdateForm = () => {
  const [filters, setFilters] = useState({
    userName: '',
    followedBy: '',
    group: null,
    taskCoordinator: null,
    loginTime: ''
  });

        const [expandedRows, setExpandedRows] = useState({});
      
        const toggleRowExpand = (taskID) => {
          setExpandedRows(prev => ({
            ...prev,
            [taskID]: !prev[taskID]
          }));
        };

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [taskCoordinators, setTaskCoordinators] = useState([]);
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const columns = [
    { name: 'User Name', selector: row => row.userName, sortable: true , center: true,

        custom:'true',
   style: {
      borderRight: '1px solid #dee2e6',
      justifyContent: 'center'
    },
  },
    { name: 'Followed By', 
      selector: row => row.followedBy, 
      sortable: true , 
      center: true,
   cell: row => (
    <div className="followed-by-cell">
      {row.followedBy}
    </div>
  ),
         style: {
    borderRight: '1px solid #dee2e6',
    justifyContent: "center",
    textAlign: "center"
  }
     },
    { name: 'Group', selector: row => row.groupName, sortable: true ,  center: true,
 
       style: {
      borderRight: '1px solid #dee2e6',
      justifyContent: 'center'
    },
   },
{
  name: "Task Name",
  selector: (row) => row.taskName,
  sortable: true,
  center: true,

  cell: (row) => {
    const text = row.taskName || "";
    const isExpanded = expandedRows[row.taskID];
    const showToggle = text.length > 100;

    return (
      <div style={{ textAlign: "left" }}>
        <div style={{ whiteSpace: "pre-wrap",  }}>
          {isExpanded ? text : text.slice(0, 100)}
          {text.length > 100 && !isExpanded && "..."}
        </div>
        {showToggle && (
          <Button
            variant="link"
            size="sm"
            className="p-0 view-more-text"
            onClick={(e) => {
              e.stopPropagation();
              toggleRowExpand(row.taskID);
            }}
          >
            {isExpanded ? "View Less" : "View More"}
          </Button>
        )}
      </div>
    );
  },
     style: {
      borderRight: '1px solid #dee2e6',
      justifyContent:'start'
     
    },
},

    {
      name: 'Updated Date', selector: row => row.updatedDate, sortable: true,  center: true,
   width: '300px',
      style: {
      borderRight: '1px solid #dee2e6',
      justifyContent: 'center'
    },
      cell: row => row.updatedDate ? new Date(row.updatedDate).toLocaleString() : 'N/A'
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const coordinatorsResponse = await apiGet('/User/GetAllUsers');
        if (coordinatorsResponse?.isSuccess) {
          const coordinators = coordinatorsResponse.data
            .filter(user => user.roleName?.toLowerCase() === 'taskcoordinator')
            .map(user => ({
              value: user.userID,
              label: user.username
            }));
          setTaskCoordinators(coordinators);
        }

        const groupsResponse = await apiGet('/Group/GetAll');
        if (groupsResponse?.isSuccess) {
          const groupOptions = groupsResponse.data.map(group => ({
            value: group.groupID,
            label: group.name
          }));
          setGroups(groupOptions);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleGroupChange = (selectedOption) => {
    setFilters(prev => ({
      ...prev,
      group: selectedOption
    }));
  };

  const handleCoordinatorChange = (selectedOption) => {
    setFilters(prev => ({
      ...prev,
      taskCoordinator: selectedOption
    }));
  };

  const handleSearch = async () => {
    setIsTableLoading(true);
    try {
      const payload = {
        GroupID: filters.group?.value || null,
        TaskCoordinatorID: filters.taskCoordinator?.value || null,
        StartDate: startDate ? startDate.toISOString() : null,
        EndDate: endDate ? endDate.toISOString() : null
      };

      const res = await apiPost('/auth/GetUserUpdateTask', payload);
      if (Array.isArray(res)) {
        const formatted = res.map(item => ({
          userName: item.userName ?? 'N/A',
          followedBy: item.followedBy ?? 'N/A',
          groupName: item.groupName ?? 'N/A',
          taskName: item.issueActionOrDecision ?? 'N/A',
          updatedDate: item.updatedDate
        }));
        setTableData(formatted);
      } else {
        console.warn('Unexpected API response format');
        setTableData([]);
      }
    } catch (err) {
      console.error('Error fetching task update data:', err);
      setTableData([]);
    } finally {
      setIsTableLoading(false);
    }
  };

  const handleClear = () => {
    setFilters({
      userName: '',
      followedBy: '',
      group: null,
      taskCoordinator: null,
      loginTime: ''
    });
    setStartDate(null);
    setEndDate(null);
    setTableData([]);
  };

 


const exportToPDF = () => {
  if (tableData.length === 0) {
    alert('No data to export!');
    return;
  }

  const doc = new jsPDF('landscape', 'pt', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 40;
  const usableWidth = pageWidth - margin * 2;

  const headers = ['User Name', 'Followed By', 'Group', 'Task Name', 'Updated Date'];
  const columnCount = headers.length;
  const columnWidth = usableWidth / columnCount;

  const columnStyles = {};
  headers.forEach((_, index) => {
    columnStyles[index] = { cellWidth: columnWidth };
  });

  const now = new Date();
  const formattedDate = new Date().toLocaleDateString('en-GB');
  doc.setFontSize(18);
  doc.setTextColor('#2c3e50');
  doc.text("User Task Update Report", margin, 40);

  doc.setFontSize(12);
  doc.text(`Date: ${formattedDate}`, pageWidth - margin - 100, 40); 

  autoTable(doc, {
    startY: 60,
    head: [headers],
    body: tableData.map(row => [
      row.userName,
      row.followedBy,
      row.groupName,
      row.taskName,
      row.updatedDate ? new Date(row.updatedDate).toLocaleString() : 'N/A'
    ]),
    styles: {
      fontSize: 11,
      cellPadding: 6,
      valign: 'middle',
      overflow: 'linebreak',
      halign: 'left',
    },
    headStyles: {
      fillColor: [44, 62, 80],
      textColor: 255,
      fontStyle: 'bold',
      halign: 'center',
    },
    columnStyles: columnStyles,
    margin: { left: margin, right: margin },
    theme: 'striped',
    alternateRowStyles: { fillColor: [245, 245, 245] },
  });

  doc.save('UserTaskUpdateReport.pdf');
};



  
  const exportToExcel = () => {
    if (tableData.length === 0) {
      alert('No data to export!');
      return;
    }

    
    const worksheetData = [
      ['User Name', 'Followed By', 'Group', 'Task Name', 'Updated Date'],
      ...tableData.map(row => [row.userName,row.followedBy,row.groupName,row.taskName,row.updatedDate ? new Date(row.updatedDate).toLocaleString() : 'N/A' ])
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "UserTaskUpdates");

  
    XLSX.writeFile(workbook, 'UserTaskUpdateReport.xlsx');
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#2c3e50',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    }
  };

  return (
    <>
      <div className="container mt-4 mb-4">
         <div className="tabs-section-wrapper mb-2">
        <div className='row'>
 <div className="d-flex justify-content-lg-center d-block tabs-section gap-3 mb-2">
          <Link to="/dashboard/reports"><Button variant="light" className="btn-tab  btn-btn-sechover">Task Detail</Button></Link>
          <Link to="/dashboard/UserLoginHistory"><Button variant="light" className="btn-tab  btn-btn-sechover">User Login History</Button></Link>
          <Link to="/dashboard/UserTaskUpdate"><Button variant="btn-primary"  className="btn-tab   btn-btn-primary">User Task Update</Button></Link>
          <Link to="/dashboard/UserFrequency"><Button variant="light" className="btn-tab btn-btn-sechover">User Frequency</Button></Link>
            <Link to="/dashboard/voiceSearch"><Button variant="light" className="btn-tab">VoiceSearch</Button></Link>
        </div>
    </div>
        </div>
        <div className='row custombox'>
          <div className='rounded p-4 mb-4'>
            <div className="text-center customheader"><h5 className="mb-0">User Task Update</h5></div>
            <Form>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Label>Group</Form.Label>
                  <Select
                    options={groups}
                    isLoading={isLoading}
                    onChange={handleGroupChange}
                    value={filters.group}
                    placeholder="Select Group"
                    isClearable
                    isSearchable
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>Task Coordinator</Form.Label>
                  <Select
                    options={taskCoordinators}
                    isLoading={isLoading}
                    onChange={handleCoordinatorChange}
                    value={filters.taskCoordinator}
                    placeholder="Select Task Coordinator"
                    isClearable
                    isSearchable
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>Date Range</Form.Label>
                  <InputGroup>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="form-control"
                      placeholderText="Select start date"
                        dateFormat="dd-MM-yyyy"
                      ref={(r) => (startDateRef.current = r)}
                    />
                    <InputGroup.Text onClick={() => startDateRef.current.setOpen(true)} style={{ cursor: 'pointer' }}>
                      <BsCalendar />
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
                <Col md={3}>
                  <Form.Label>&nbsp;</Form.Label>
                  <InputGroup>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      className="form-control"
                      placeholderText="Select end date"
                        dateFormat="dd-MM-yyyy"
                      ref={(r) => (endDateRef.current = r)}
                    />
                    <InputGroup.Text onClick={() => endDateRef.current.setOpen(true)} style={{ cursor: 'pointer' }}>
                      <BsCalendar />
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Row>

              <div className="text-center mt-4">
                <Button variant="btn-primary" className="px-4 me-3 btn-fontweight" onClick={handleSearch}>Search</Button>
                <Button variant="secondary" className="px-4 btn-fontweight" onClick={handleClear}>Clear</Button>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <Button className="me-2 btn-fontweight custompdf-btn" onClick={exportToPDF}>Export to PDF</Button>
            <Button  className='btn-fontweight customexport-btn' onClick={exportToExcel}>Export to Excel</Button>
          </div>
        </div>
        <div className="card shadow-sm rounded-4 py-4 px-0  border-0 bg-white mb-custom">
          <DataTable
            columns={columns}
         data={tableData.map((dept, idx) => ({
    ...dept,
    _rowIndex: idx, 
  }))}
 
            progressPending={isTableLoading}
            pagination
            striped
          className="p-datatable-striped customuser-data-table customarchive-data-table dashboard-table"
      customStyles={{
              table: {
                style: {
              fontWeight: '600',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
      textAlign: 'center',
                },
              },
              headRow: {
                style: {
                  backgroundColor: "#04364A!important",
                  minHeight: "48px",
                    textAlign: 'center',

                },
              },
              headCells: {
                style: {
                  padding: "10px 14px",
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "white",
                  textTransform: "uppercase",
                   textAlign: columns.name === "Issue/Action/Decision" ? "center" : "left",
                },
              },
           
              cells: {
                style: {
                  padding: "10px 14px",
                  fontSize: "14px",
                  color: "#334155",
                },
              },
            }}
      conditionalRowStyles={[
     {
    when: (row) => row._rowIndex % 2 === 0, 
    style: { backgroundColor: '#f2f2f2' },
  },
  {
    when: (row) => row._rowIndex % 2 !== 0,
    style: { backgroundColor: '#ffffff' },
  },
  ]} 
     
          />
        </div>
      </div>
    </>
  );
};

export default UserTaskUpdateForm;
